export default __webpack_public_path__ + "static/media/Guestbookmessages.5c7682bc.PNG";